import * as undoActions from 'owa-mail-undo';
import datapoints from '../datapoints';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { actionNames, DeleteConversationStoreUpdate } from 'owa-mail-store-actions';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { raiseAction } from 'satcheljs/lib/legacy/stitch';
import { setConversationInferenceClassificationService } from 'owa-mail-triage-action/lib/services/setConversationInferenceClassificationService';
import { handleServerResponseSuccessAndError } from 'owa-mail-triage-action-response-processor';

/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param actionSource the source that initiated this action
 * @return the action response
 */
export default createLegacyActionWithDatapoint(
    'moveConversationToFocusedOrOtherAction',
    datapoints.moveConversationToFocusedOrOther
)(function moveConversationToFocusedOrOther(
    conversationRowKeys: string[],
    tableViewId: string,
    toViewFilter: FocusedViewFilter,
    actionSource: ActionSource
): Promise<void> {
    const tableView: TableView = listViewStore.tableViews.get(tableViewId);
    const isFocusedView: boolean = toViewFilter == FocusedViewFilter.Focused;
    const conversationIdStrings = getRowIdsFromRowKeys(conversationRowKeys, tableViewId);

    undoActions.clearLastUndoableAction();

    const setInferenceClassificationPromise = setConversationInferenceClassificationService(
        conversationIdStrings,
        isFocusedView ? 'Focused' : 'Other'
    );

    returnTopExecutingActionDatapoint().markUserPerceivedTime();

    // raise stitch to delete conversation from list view and reading pane
    // VSO 20053:Tombstone not working when moving conversation from focused to other
    raiseAction<DeleteConversationStoreUpdate>(actionNames.DeleteConversationStoreUpdate)(
        conversationIdStrings,
        tableView
    );

    return setInferenceClassificationPromise.then(response => {
        return handleServerResponseSuccessAndError(response);
    });
});
